import { Component, OnInit } from '@angular/core';
import { SessionExpiryLabel_EN } from '../../models/labels/sessionExpiryLabel_EN';
import { MainHeaderlabel_EN } from '../../models/labels/mainHeaderLabel_EN';
import { FooterLabel_EN } from '../../models/labels/footerLabel_EN';
import { LoginRenderingService } from '../../services/login/login-rendering.service';
import { Router } from '@angular/router';
import { BorrowerRenderingService } from '../../services/borrower/borrower-rendering.service';
import { QuoteRenderingService } from '../../services/search/quote-rendering.service';
import { AuthorisationService } from '../../services/authorisation/authorisation.service';
import { BorrowerDTO } from '../../models/borrower/borrower-dto';
import { IncomeDTO } from '../../models/borrower/income-dto';
import { LoanStep1 } from '../../models/borrower/loan-step1';
import { LoanStep2 } from '../../models/borrower/loan-step2';
import { Parameter } from '../../models/borrower/loanFormParameter';
import { NewQuote } from '../../models/search/new-quote';
import { QuotationEntityIdDto } from '../../models/search/quotation-entity-id-dto';
import { SearchQuote } from '../../models/search/search-quote';
import { ApiService } from '../../services/api/api.service';
import { environment } from '../../../environments/environment.prod';

@Component({
  selector: 'app-on-logout',
  templateUrl: './on-logout.component.html',
  styleUrls: ['./on-logout.component.scss']
})
export class OnLogoutComponent implements OnInit {

  message: SessionExpiryLabel_EN;
  headerLabel: MainHeaderlabel_EN;
  footerLabel: FooterLabel_EN;
  logoname: string;
  env: string = environment.apiURL.env;
  nissanUrl: string = environment.apiURL.nUrl;
  preprodUrl: string = environment.apiURL.preUrl;
  preprod: boolean = false;

  constructor(private router: Router, private borrowerService: BorrowerRenderingService,
    private authorisationService: AuthorisationService, private data: ApiService,
    private quoteService: QuoteRenderingService, private loginService: LoginRenderingService) { }

  ngOnInit() {
    this.message = new SessionExpiryLabel_EN();
    this.headerLabel = new MainHeaderlabel_EN();
    this.footerLabel = new FooterLabel_EN();
    this.logoname = this.data.setLogoName();
    if (this.env.includes('preprod')) {
      this.preprod = true;
    } else {
      this.preprod = false;
    }
    return this.preprod;
  }


  loginPage() {
    this.authorisationService.logout();
    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    // this.router.navigate(['/login']);
  }
}
